import * as React from 'react'

import { SearchField } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
}

const SearchBar = ({ onSearch, search }: Props) => {
  return (
    <SearchField
      variant="big"
      placeholder={i18n.t('bookkeepers.incidence.table.search_name_lastname')}
      search={search}
      onSearch={onSearch}
    />
  )
}

export default observer(SearchBar)
